module.exports = __webpack_public_path__ + "img/压缩空气泡沫智能消防车@1x.898ea857.png";